<template>
  <div class="msg_box">
    <img src="../assets/img/home/icon-3.png" alt="" />
    <div class="wrap">
      <div id="box">
        <div id="marquee" ref='cont' v-html="lists.title" @click="goMsg(lists.id)"
             :class="{ current: current == lists.id}"
             @mouseenter="Stop()"
             @mouseleave="Up()">
        </div>
<!--        <div id="node" ref='cont' v-html="lists.title" @click="goMsg(lists.id)" :class="{ current: current == lists.id}"-->
<!--             @mouseenter="Stop()"-->
<!--             @mouseleave="Up()">-->
<!--        </div>-->

      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["lists"], // 父组件传入数据， 数组形式 [ "连雨不知春去"，"一晴方觉夏深"]
  data() {
    return {
        list: "", // 数组文字转化后的字符串
        current: -1,
        distance: 0,
        scrollTime: undefined,

    };
  },
  methods: {

      Stop(id) {
          // this.current = id
          clearInterval(this.scrollTime)
      },
      Up() {
          // this.current = -1
          // this.move()
      },
      goMsg(item) {
          this.$router.push({
              path: "/msgDetail",
              query: {
                  id: item,
              },
          });
      },

    move() {

      // 获取文字text 的计算后宽度  （由于overflow的存在，直接获取不到，需要独立的node计算）
        let heights = document.getElementById("node").getBoundingClientRect().height;
      let box = document.getElementById("box");
        let distance = 0
      // 设置位移
        this.scrollTime = setInterval(function () {
        distance = distance - 1;
        // 如果位移超过文字宽度，则回到起点
            if (-distance >= heights) {
                distance = 1;
        }
            box.style.transform = "translatey(" + distance + "px)";
        }, 100);
    },
  },
  // 把父组件传入的arr转化成字符串
  mounted: function () {
      // this.move()
  },
  // 更新的时候运动
  updated: function () {
    // this.move();
  },
};
</script>
<style lang="less" scoped>
/*样式的话可以写*/

.current {
  background-color: #f85415;
  color: #fff !important;
}
.msg_box {
  display: flex;
  align-items: center;
    width: 500px;
    height: 50px;
  line-height: 40px;
  margin: 30px auto;
    margin-top: 70px;
  background-color: #FFF0E9; //#f4f4f4;
  /* opacity: 0.1; */
  font-size: 16px;
  color: #ff6829; //#4490e6;
  border-radius: 20px;
  /*padding: 0 30px;*/
  box-sizing: border-box;
  img {
    width: 27px;
    height: 23px;
  }
}
.wrap {
  width: 400px;
  height: 40px;
  line-height: 40px;
  margin: 10px auto;
  overflow: hidden;
}
#box {
  padding-left: 20px;
  width: 500%;
}
#box div {
  float: left;
}
#marquee {
  margin: 0 30px 0 0;
}
#node {
  position: absolute;
  z-index: -10;
  top: -30px;
}
</style>
